module.exports = __webpack_public_path__ + "../resources/img/ic_module_layout.1095c82d.svg";